import { render } from "./index.vue?vue&type=template&id=1ea4b89a"
const script = {}

import exportComponent from "/home/runner/work/uivjs-admin/uivjs-admin/example/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__